import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

import { DndProvider, useDrag, useDrop } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const ItemTypes = {
  SHOP_CARD: 'shop_card'
}

const groupGridInPage = 3;


const splitList = (list, number) => {

  const resultList = []
  var innerList = []
  
  list.forEach((data, i) => {
    innerList.push(data);

    if ((i % number) === i - 1 || i === list.length - 1) {
      resultList.push(innerList);
      innerList = [];
    }
  })

  return resultList;
 
}

function ShopCard ({ shopData }) {
  const [{isDragging}, drag] = useDrag(() => ({
    type: ItemTypes.SHOP_CARD,
    item: shopData,
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }))

  return (
    <Box ref={drag} opacity={isDragging ? 0.5 : 1} backgroundColor="white" border="1px black solid" padding={1} width={120}>
      <Typography opacity={isDragging ? 0.5 : 1} fontSize={16}>{shopData.name}</Typography>
    </Box>
  )  
}

function GroupBox ({ groupData, onDropShopCard, onClickDelete }) {

  const shops = groupData.shops;

  const [{}, drop] = useDrop(() => ({
    accept: ItemTypes.SHOP_CARD,
    drop: (item, monitor) => { onDropShopCard( item.shop_id, groupData.group_id )},
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    })
  }), []);

  const boxTitle = groupData.group_name ? groupData.group_name : "[グループ未設定]";

  return (      
    <Box ref={drop} style={{backgroundColor: "#f8f8f8", padding:10, border:"1px black solid"}}>
      <Box height={40} marginBottom={1}>
        <Grid container alignItems='center' justifyContent="center" height="100%">
          <Grid item xs>
            <Typography fontWeight={600} fontSize={20}>{boxTitle}</Typography>
          </Grid>
          <Grid item xs='auto'>
            {
              groupData.group_id ?
              (
                <Button color='error' onClick={onClickDelete} sx={{fontSize:15, fontWeight: 600, padding:0.5, minWidth:30}}>
                  削除
                </Button>
              )
              : null
            }
          </Grid>
        </Grid>
      </Box> 

      <Grid container alignItems="start" spacing={1}>            
        {
          shops.map((shopData) => (
            <Grid key={"shopGrid_" +shopData.shop_id} item xs="auto">
              <ShopCard key={"shop_" +shopData.shop_id} shopData={shopData} />
            </Grid>
          ))
        }
      </Grid>          
    </Box>
  )
}

// 店舗グループ編集領域
export default function ShopGroupEditArea ({
  ungroupedShops, shopGroupedList, changeGroup, onClickDeleteGroup
}) {

  const onDropShopCard = (shop_id, group_id) => {
    changeGroup(shop_id, group_id);
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <Box marginBottom={2}>
        <GroupBox
          groupData={{group_id: null, group_name:null, shops: ungroupedShops}}
          onDropShopCard={onDropShopCard}
          onClickDelete={null}
        /> 
      </Box>

      <Divider orientation="horizontal" variant="middle" sx={{marginX: 0, backgroundColor: "#4f4f4f"}}/>

      <Box display="flex" flexDirection="column" marginTop={2}>
        <Box sx={{flex: 1, overflowY:"scroll"}} > 
          <Grid container spacing={2}>
            {
              shopGroupedList.map((groupData) => (
                <Grid item key={`groupGrid_${groupData.group_id}`} xs={4}>
                  <GroupBox
                    key={"groupBox_" + groupData.group_id}
                    groupData={groupData}
                    onDropShopCard={onDropShopCard}
                    onClickDelete={onClickDeleteGroup(groupData)}
                  />
                </Grid>
              ))
            }
          </Grid>
        </Box>
      </Box>
    </DndProvider>
  )
}

